import styled from 'styled-components'
import { iPadDown } from '../../../styles/mediaQueries'

interface StyledCaretProps {
  flipped: boolean
}

export const StyledCaret = styled.svg<StyledCaretProps>`
  height: 0.5vw;
  width: auto;
  ${({ flipped }) => (flipped ? 'transform: scaleY(-1);' : '')}

  ${iPadDown} {
    height: 1.55vw;
  }
`
